import type { AxiosResponse } from 'axios';

export function getXLocation(axiosResponse: AxiosResponse): string | null {
    if (!axiosResponse) {
        return null;
    }

    const { headers } = axiosResponse;

    if (!(headers as { 'x-location'?: unknown })['x-location']) {
        return null;
    }

    const xLocation: unknown = (headers as { 'x-location': unknown })['x-location'];

    return typeof xLocation === 'string' ? xLocation : null;
}
